import React, { useState } from 'react';
import { Form } from 'react-bootstrap';
import logo from '../assets/img/logo.png';
import { login } from '../services/loginServices';
import { myRole } from '../services/roleServices';

function Login() {
  const [form, setForm] = useState({
    username: '',
    password: '',
  });

  const [errorMsg, setErrorMsg] = useState(''); // ✨ New

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prevForm) => ({
      ...prevForm,
      [name]: value,
    }));
    setErrorMsg(''); // Clear error on input change
  };

  const submit = async (event) => {
    event.preventDefault();
    setErrorMsg('');
    event.stopPropagation();
    const response = await login(form);
    if (response && response.token) {
      localStorage.setItem('token', response.token);
      localStorage.setItem('role', response.role);
      if(response.role === "event"){
        localStorage.setItem('sub_domain', form.username);
      }
      if (localStorage.getItem('token')) {
        if (myRole() === 'admin') {
          window.location.href = '/transactionStatus';
        } else if (myRole() === 'event') {
          window.location.href = '/dashboard';
        } else if (myRole() === 'finance') {
          window.location.href = '/revenue';
        } else if (myRole() === 'management') {
          window.location.href = '/mgmtTransactionStatus';
        }     
      }
     } else if (response && response.error) {
      setErrorMsg(response.error); // ✨ Set error message
    }
  }

  return (
    <div data-theme="default" data-layout="fluid" data-sidebar-position="left" data-sidebar-layout="default">
      <main className="d-flex w-100 h-100 bg-dark">
        <div className="container d-flex flex-column">
          <div className="row vh-100">
            <div className="col-sm-10 col-md-8 col-lg-6 col-xl-5 mx-auto d-table h-100">
              <div className="d-table-cell align-middle">
                <div className="text-center mt-4">
                  <img className="pb-4" src={logo} width="280px" alt="Scientex Conferences" />
                </div>
                {errorMsg && (
                  <div className="alert alert-danger mt-3 p-3" role="alert">
                    {errorMsg}
                  </div>
                )}
                <div className="card">
                  <div className="card-body">
                    <div className="m-sm-3">
                      <Form>
                        <Form.Group className="mb-3">
                          <Form.Label>Username</Form.Label>
                          <Form.Control
                            type="text"
                            name="username"
                            value={form.username}
                            onChange={handleChange}
                            placeholder="Enter your username"
                            isInvalid={!!errorMsg}
                          />
                        </Form.Group>

                        <Form.Group className="mb-3">
                          <Form.Label>Password</Form.Label>
                          <Form.Control
                            type="password"
                            name="password"
                            value={form.password}
                            onChange={handleChange}
                            placeholder="Enter your password"
                            isInvalid={!!errorMsg}
                          />
                        
                          <small>
                            <p>* Contact Admin for Password Reset</p>
                          </small>
                        </Form.Group>

                        <div className="d-grid gap-2 mt-3">
                          <button className="btn btn-lg btn-primary" onClick={submit}>
                            Sign in
                          </button>
                        </div>
                      </Form>
                    </div>
                  </div>
                </div>

                <div className="text-center mb-3">
                  Welcome to Scientex Conferences CMS Portal
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}

export default Login;